<template>
  <div>
    <!-- snapshotDetail -->
    <snapshot-detail @update:filter="filter = $event" v-bind:snapshot="this.snapshot" title="Snapshot" />

    <!-- All listings attached to this snapshot  -->
    <div v-if="this.snapshot != null">
      <div v-if="this.snapshot.soldTotalQty > 0">
        <sold-items-list v-bind:soldItems="this.soldItems" @soldItems-changed="onListChanged" @update:options="updateOptions($event)" />
      </div>
      <div v-else>
        <listing-list v-bind:listings="this.listings" :snapshot-id="this.snapshot.id" @listings-changed="onListChanged" @update:options="updateOptions($event)" />
      </div>
    </div>
  </div>
</template>

<script>
// Components
import SnapshotDetail from '../components/snapshots/snapshot-detail.vue';
import ListingList from '../components/listings/listing-list.vue';
import SoldItemsList from '../components/soldItems/soldItems-list.vue';

import { SnapshotsService } from '../services/api/snapshots';
const apiSnapshots = new SnapshotsService();

export default {
  components: {
    SnapshotDetail,
    ListingList,
    SoldItemsList,
  },

  data() {
    return {
      snapshot: {
        soldItems: null,
        listings: null,
      },
      soldItems: null,
      listings: null,
      filter: 'refined', // Default filter option
      sortBy: null,
      sortDesc: false,
    }
  },

  created() {
    // // Listen to status changes coming from SignalR events
    // this.$scannerHub.$on('scan-completed', this.onScanCompleted)

    // If this is a "Latest Snapshot" request, then:
    if (this.$route.name === "Latest Snapshot") {
      // Load the latest snapshot.
      apiSnapshots.getLatestSnapshotForCatCode(this.$route.params.catCode, { filter: this.filter }).then((data) => {
        this.snapshot = data;
        this.setSoldItemsOrListings(this.snapshot);
      });
    } else if (this.$route.name === "Latest Snapshot for Marketplace") {
      // Load the latest snapshot for the marketplace.
      apiSnapshots.getLatestSnapshotForMarketplace(this.$route.params.marketplace, this.$route.params.catCode, { filter: this.filter }).then((data) => {
        this.snapshot = data;
        this.setSoldItemsOrListings(this.snapshot);
      });

    } else {
      // Else load the snapshot by id
      apiSnapshots.getSnapshot(this.$route.params.id, { filter: this.filter }).then((data) => {
        this.snapshot = data;
        this.setSoldItemsOrListings(this.snapshot);
      });
    }
  },
  watch: {
    // Watch for changes to the usOnly prop and emit an event to update the parent component.
    filter(newFilterVal) {
      console.log("snapshot.vue: filter called with:", newFilterVal);

      apiSnapshots.getSnapshot(this.snapshot.id, { filter: newFilterVal }).then((data) => {
        this.snapshot = data
        this.setSoldItemsOrListings(this.snapshot);
      });
    }
  },

  methods: {
    // onScanCompleted({ newSnapshotID }) {
    //   // TODO:  Refine this api call so it returns the part ID as well as the snapshot ID.
    //   //        This way we could check the PartID before making the call below to getSnapshot.
    //   apiSnapshots.getSnapshot(newSnapshotID).then((data) => {
    //     if (this.snapshot.partID == data.partID)
    //       // Update our UI to show this snapshot
    //       this.snapshot = data;
    //   });
    // },
    updateOptions(options) {
      console.log("update options called with:", options);
      
      // Update the options object with the new sortBy value.
      this.sortBy = options.sortBy;
      this.sortDesc = options.sortDesc;
      this.sortSoldItemsOrListings();
    },
    onListChanged() {
      console.log("onListingsChanged");
      // Reload the snapshot.
      apiSnapshots.getSnapshot(this.snapshot.id).then((data) => {
        this.snapshot = data
        this.setSoldItemsOrListings();
      });
    },
    setSoldItemsOrListings() {
      if (!this.snapshot.id) return;
      if (this.snapshot.soldTotalQty > 0) {
        this.soldItems = [ ...this.snapshot.soldItems ];
        this.processSoldItems(this.soldItems);
        this.sortSoldItemsOrListings();;
      } else {
        this.listings = [ ...this.snapshot.listings ];
        this.sortSoldItemsOrListings();
      }
    },
    sortSoldItemsOrListings() {
      if (this.snapshot.soldTotalQty > 0) {
        this.sortSoldItems(this.soldItems);
      } else {
        this.sortListings(this.listings);
      }
    },
    processSoldItems(soldItems) {
      // Process the sold items to ensure they have the correct structure.
      for (const soldItem of soldItems) {
        switch (soldItem.shippingPrice) {
          case 0:
            soldItem.shippingPrice = "Free";
            break;
          case null:
            soldItem.shippingPrice = "Unknown";
            break;
          default:
            soldItem.shippingPrice = soldItem.shippingPrice.toFixed(2);
        }

        if (!soldItem.listing) {
          soldItem.listing = {};
        }
        if (!soldItem.listing.seller) {
          soldItem.listing.seller = {};
        }
        if (!soldItem.listing.seller.eBayStoreName) {
          soldItem.listing.seller.eBayStoreName = soldItem.listing.seller.userID || '[ No Listing ]';
        }
        if (!soldItem.listing.location) {
          soldItem.listing.location = '[ No Listing ]';
        }
      }
    },
    sortSoldItems(soldItems) {
      const useDefaultSort = !this.sortBy;
      if (useDefaultSort) {
        // Sort by date sold, then by sale price, then by shipping price, then by title.
        soldItems.sort((a, b) => {
          if (a.dateSold != b.dateSold) {
            return new Date(b.dateSold) - new Date(a.dateSold);
          }

          const priceA = a.salePrice == 0 ? Number.MAX_SAFE_INTEGER : a.salePrice;
          const priceB = b.salePrice == 0 ? Number.MAX_SAFE_INTEGER : b.salePrice;

          if (priceA != priceB) {
            return priceA - priceB;
          }

          if (a.shippingPrice != b.shippingPrice) {
            return b.shippingPrice - a.shippingPrice;
          }
          return b.title.localeCompare(a.title);
        });
      } else {
        soldItems.sort((a, b) => {
          // Sort by the field specified in options.sortBy
          const field = this.sortBy;

          // split by '.' if it's a nested field
          const fieldParts = field.split('.');
          const aValue = fieldParts.reduce((obj, part) => obj && obj[part], a);
          const bValue = fieldParts.reduce((obj, part) => obj && obj[part], b);
          if ((aValue === undefined || aValue == null) && (bValue === undefined || bValue == null)) {
            // If both values are undefined or null, treat them as equal
            return 0;
          }

          if (aValue === undefined || aValue == null) {
            return this.sortDesc ? 1 : -1; // Treat undefined and null as greater if sorting descending
          }
          if (bValue === undefined || bValue == null) {
            return this.sortDesc ? -1 : 1; // Treat undefined and null as lesser if sorting descending
          }

          // Compare the values
          if (aValue < bValue) {
            return this.sortDesc ? 1 : -1;
          } else if (aValue > bValue) {
            return this.sortDesc ? -1 : 1;
          }

          if (a[field] < b[field]) {
            return this.sortDesc ? 1 : -1;
          } else if (a[field] > b[field]) {
            return this.sortDesc ? -1 : 1;
          }
          return 0; // Equal
        });
      }
    },
    sortListings(listings) {
      const useDefaultSort = !this.sortBy;
      if (useDefaultSort) {
        // Sort by price, then by quantity remaining.
        // If the price is 0, then treat it as a very high price so it sorts to the end.
        listings.sort((a, b) => {
          const priceA = a.price == 0 ? Number.MAX_SAFE_INTEGER : a.price;
          const priceB = b.price == 0 ? Number.MAX_SAFE_INTEGER : b.price;

          if (priceA == priceB) {
            return b.quantityRemaining - a.quantityRemaining;
          }
          return priceA - priceB;
        });
      } else {
        listings.sort((a, b) => {
          // Sort by the field specified in options.sortBy
          const field = this.sortBy;

          // split by '.' if it's a nested field
          const fieldParts = field.split('.');
          const aValue = fieldParts.reduce((obj, part) => obj && obj[part], a);
          const bValue = fieldParts.reduce((obj, part) => obj && obj[part], b);
          if ((aValue === undefined || aValue == null) && (bValue === undefined || bValue == null)) {
            // If both values are undefined or null, treat them as equal
            return 0;
          }

          if (aValue === undefined || aValue == null) {
            return this.sortDesc ? 1 : -1; // Treat undefined and null as greater if sorting descending
          }
          if (bValue === undefined || bValue == null) {
            return this.sortDesc ? -1 : 1; // Treat undefined and null as lesser if sorting descending
          }

          // Compare the values
          if (aValue < bValue) {
            return this.sortDesc ? 1 : -1;
          } else if (aValue > bValue) {
            return this.sortDesc ? -1 : 1;
          }

          if (a[field] < b[field]) {
            return this.sortDesc ? 1 : -1;
          } else if (a[field] > b[field]) {
            return this.sortDesc ? -1 : 1;
          }
          return 0; // Equal
        });
      }
    }
  }
}
</script>